import styled from 'styled-components';

export const StyledBlockquote = styled.blockquote`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
